/**
 * Lets a page-level sticky CTA (e.g. StickyBPOCTA) tell the global
 * StickyCTABar to step aside, so two fixed bars never stack on mobile.
 */
import { useEffect, useSyncExternalStore } from 'react';

let count = 0;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function registerPageStickyCta(): () => void {
  count += 1; emit();
  return () => { count = Math.max(0, count - 1); emit(); };
}

export function hasPageStickyCta(): boolean { return count > 0; }

export function usePageStickyCtaActive(): boolean {
  return useSyncExternalStore(
    (l) => { listeners.add(l); return () => { listeners.delete(l); }; },
    hasPageStickyCta,
    () => false,
  );
}

export function useRegisterPageStickyCta(): void {
  useEffect(() => registerPageStickyCta(), []);
}
